// // useURLState.js
// import { useEffect, useRef } from 'react';
// import { encodeStateToURL, decodeURLToState, updateURL } from './urlStateUtils';

// /**
//  * Custom hook to synchronize palette state with URL
//  * @param {Object} paletteState - Current palette state
//  * @param {Function} setPaletteState - Function to update palette state
//  * @param {Array} squareNames - Array of square names
//  * @returns {Object} - Hook utilities
//  */
// export const useURLState = (paletteState, setPaletteState, squareNames) => {
//   const isInitialized = useRef(false);
//   const isUpdatingFromURL = useRef(false);
//   const isUpdatingURL = useRef(false);

//   // Load state from URL on mount
//   useEffect(() => {
//     if (isInitialized.current) return;

//     const currentPath = window.location.pathname;
//     if (currentPath && currentPath !== '/' && currentPath !== '/generator') {

//       const decodedState = decodeURLToState(currentPath, squareNames);

//       if (decodedState && decodedState.color) {
//         isUpdatingFromURL.current = true;
//         setPaletteState(decodedState);

//         // Reset flag after state updates
//         setTimeout(() => {
//           isUpdatingFromURL.current = false;
//         }, 100);
//       }
//     }

//     isInitialized.current = true;
//   }, []);

//   // Handle browser back/forward navigation
//   useEffect(() => {
//     console.log('👂 popstate listener attached');
//     const handlePopState = () => {
//       console.log('🔙 popstate fired', { currentPath: window.location.pathname });
//       const currentPath = window.location.pathname;
//       // Skip processing if we're on the base generator page
//       if (currentPath === '/generator') {
//         return;
//       }
//       const decodedState = decodeURLToState(currentPath, squareNames);

//       if (decodedState) {
//         isUpdatingFromURL.current = true;
//         console.log('🔒 isUpdatingFromURL set to TRUE');
//         setPaletteState(decodedState);

//         setTimeout(() => {
//           isUpdatingFromURL.current = false;
//           console.log('🔓 isUpdatingFromURL set to FALSE');
//         }, 100);
//       } else {
//         // If URL is invalid, redirect to root and reset state
        // setPaletteState({
        //   color: null,
        //   colorDuo: null,
        //   colorTrio: null,
        //   showDuo: false,
        //   showTrio: false,
        //   paletteModifiers: {
        //     scale: {
        //       hue: 0,
        //       lightnessLeft: 0,
        //       lightnessRight: 0,
        //       saturationLeft: 0,
        //       saturationRight: 0
        //     },
        //     individual: {}
        //   },
        //   paletteModifiersDuo: {
        //     scale: {
        //       hue: 0,
        //       lightnessLeft: 0,
        //       lightnessRight: 0,
        //       saturationLeft: 0,
        //       saturationRight: 0
        //     },
        //     individual: {}
        //   },
        //   paletteModifiersTrio: {
        //     scale: {
        //       hue: 0,
        //       lightnessLeft: 0,
        //       lightnessRight: 0,
        //       saturationLeft: 0,
        //       saturationRight: 0
        //     },
        //     individual: {}
        //   }
        // });
//       }
//     };

//     window.addEventListener('popstate', handlePopState);
//     return () => {
//       console.log('👂 popstate listener removed');
//       window.removeEventListener('popstate', handlePopState);
//     };
//   }, [squareNames, setPaletteState]);

//   return {
//     isUpdatingFromURL: isUpdatingFromURL.current,
//     isUpdatingURL: isUpdatingURL.current
//   };
// };






















// useURLState.js
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { decodeURLToState } from './urlStateUtils';

export const useURLState = (paletteState, setPaletteState, squareNames) => {
  const isInitialized = useRef(false);
  const isUpdatingFromURL = useRef(false);
  const isUpdatingURL = useRef(false);
  const location = useLocation();

  // Load state from URL on mount
  useEffect(() => {
    if (isInitialized.current) return;
    const currentPath = window.location.pathname;
    if (currentPath && currentPath !== '/' && currentPath !== '/generator') {
      const decodedState = decodeURLToState(currentPath, squareNames);
      if (decodedState && decodedState.color) {
        isUpdatingFromURL.current = true;
        setPaletteState(decodedState);
        setTimeout(() => {
          isUpdatingFromURL.current = false;
        }, 500);
      }
    }
    isInitialized.current = true;
  }, []);

  // Handle back/forward navigation via React Router
  useEffect(() => {
    if (!isInitialized.current) return;

    const currentPath = location.pathname;

    if (currentPath === '/generator' || currentPath === '/') return;

    const decodedState = decodeURLToState(currentPath, squareNames);

    if (decodedState && decodedState.color) {
      isUpdatingFromURL.current = true;
      setPaletteState(decodedState);
      setTimeout(() => {
        isUpdatingFromURL.current = false;
      }, 500);
    } else {
      // If URL is invalid, redirect to root and reset state
      setPaletteState({
        color: null,
        colorDuo: null,
        colorTrio: null,
        showDuo: false,
        showTrio: false,
        paletteModifiers: {
          scale: {
            hue: 0,
            lightnessLeft: 0,
            lightnessRight: 0,
            saturationLeft: 0,
            saturationRight: 0
          },
          individual: {}
        },
        paletteModifiersDuo: {
          scale: {
            hue: 0,
            lightnessLeft: 0,
            lightnessRight: 0,
            saturationLeft: 0,
            saturationRight: 0
          },
          individual: {}
        },
        paletteModifiersTrio: {
          scale: {
            hue: 0,
            lightnessLeft: 0,
            lightnessRight: 0,
            saturationLeft: 0,
            saturationRight: 0
          },
          individual: {}
        }
      });
    }
  }, [location.pathname]);

  return {
    isUpdatingFromURL: isUpdatingFromURL.current,
    isUpdatingURL: isUpdatingURL.current
  };
};